var render = function render(_c, _vm) {
  return _c("div", { staticStyle: { "background-color": "var(--white)" } }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("wa-usage-messages", {
          attrs: { "message-groups": ["dire"], type: "kit" },
        }),
        _vm._v(" "),
        _c("wa-usage-messages", {
          attrs: { "message-groups": ["dire"], "is-last": "", type: "npm" },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }